import React from "react";

import { PracticeUsersDetail } from "../user";

export default function Detail(props) {
  return <PracticeUsersDetail {...props} isAdmin />;
}
